import { useGlobalModalsContext } from 'contexts/globalModalsContext';
import Button from 'ui/Button';
import Icon from 'ui/Icon';

const SaveButton: React.FC = () => {
  const { openConversionModal } = useGlobalModalsContext();

  return (
    <>
      <Button
        flexShrink={0}
        onClick={() => openConversionModal('Saving')}
        variant="primary-solid"
        size="sm"
      >
        Save diagram <Icon icon="crown" />
      </Button>
    </>
  );
};

export default SaveButton;
